(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maeve-social-proof"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.maeve-social').forEach(function (root) {
  var track = root.querySelector('.social-track');
  var bar = root.querySelector('.social-progress-bar');
  function upd() {
    if (!track || !bar) return;
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max > 0 ? track.scrollLeft / max : 0;
    var vis = track.clientWidth / track.scrollWidth;
    var w = Math.max(vis, 0.12) * 100;
    bar.style.width = w + '%';
    bar.style.marginLeft = (ratio * (100 - w)) + '%';
  }
  if (track) { track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd(); }
  root.querySelectorAll('.sp-play').forEach(function (btn) {
    if (btn.tagName === 'A') return;
    btn.addEventListener('click', function () {
      var vid = btn.parentNode.querySelector('video');
      if (vid) { vid.play(); btn.classList.add('is-hidden'); var cap = btn.parentNode.querySelector('.sp-cap'); if (cap) cap.style.display = 'none'; }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
